import React from "react";

import HomeUI from "../../../../ui/homeUI/_index";

const ElectronicReciverReport = () => {
  return (
    <>
      <HomeUI />
    </>
  );
};

export default ElectronicReciverReport;
